import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomSwitcher = (props) => (
  <Header {...props}>
    <span>IBM Maximo REST API Guide</span>
  </Header>
);

export default CustomSwitcher;
